'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _regeneratorRuntime = require('@babel/runtime/regenerator');
var _asyncToGenerator = require('@babel/runtime/helpers/asyncToGenerator');
var _assertThisInitialized = require('@babel/runtime/helpers/assertThisInitialized');
var _inheritsLoose = require('@babel/runtime/helpers/inheritsLoose');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var React = require('react');
var Loads = require('react-loads');
var _get = require('lodash/get');
var _isEmpty = require('lodash/isEmpty');
var bumbag = require('bumbag');
var faEdit = require('@fortawesome/pro-solid-svg-icons/faEdit');
var sdk = require('@medipass/web-sdk');
var HICAPS = require('@medipass/assets/images/hicaps.svg');
var TyroLogo = require('@medipass/assets/images/tyro-logo.png');
var funders = require('@medipass/utils/funders');
var constants = require('@medipass/utils/constants');
var transactionStatus = require('@medipass/utils/transaction-status');
var components_DescriptionLabel = require('../../../components/DescriptionLabel.js');
var WithErrorMessage = require('../../../WithErrorMessage.js');
var WithLoadingIndicator = require('../../../WithLoadingIndicator.js');
var HealthFundAccounts_components_HealthFundAccountBox = require('../../../HealthFundAccounts/components/HealthFundAccountBox.js');
var HealthFundAccounts_components_MedicareBankDetails = require('../../../HealthFundAccounts/components/MedicareBankDetails.js');
var HealthFundAccounts_components_MedicareDefaultAddress = require('../../../HealthFundAccounts/components/MedicareDefaultAddress.js');
var Transactions_components_consumer_ClaimStatus = require('./ClaimStatus.js');
var Transactions_components_consumer_MedicareTransactionPDF = require('./MedicareTransactionPDF.js');
var reactFontawesome = require('@fortawesome/react-fontawesome');
require('@babel/runtime/helpers/objectWithoutPropertiesLoose');
require('@babel/runtime/helpers/taggedTemplateLiteralLoose');
require('clsx');
require('../../../components/ErrorMessage.js');
require('@fortawesome/pro-regular-svg-icons/faSpinnerThird');
require('../../../components/BriefDetailBox.js');
require('formik');
require('@medipass/utils/validate-form');
require('../../../components/AddressField.js');
require('@babel/runtime/helpers/extends');
require('react-loads-next');
require('use-debounce');
require('bumbag-addon-markdown');
require('@medipass/utils/claim-payment-status-text-classes');
require('./StatusText.js');
require('file-saver');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _regeneratorRuntime__default = /*#__PURE__*/_interopDefaultLegacy(_regeneratorRuntime);
var _asyncToGenerator__default = /*#__PURE__*/_interopDefaultLegacy(_asyncToGenerator);
var _assertThisInitialized__default = /*#__PURE__*/_interopDefaultLegacy(_assertThisInitialized);
var _inheritsLoose__default = /*#__PURE__*/_interopDefaultLegacy(_inheritsLoose);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Loads__default = /*#__PURE__*/_interopDefaultLegacy(Loads);
var _get__default = /*#__PURE__*/_interopDefaultLegacy(_get);
var _isEmpty__default = /*#__PURE__*/_interopDefaultLegacy(_isEmpty);
var sdk__default = /*#__PURE__*/_interopDefaultLegacy(sdk);
var HICAPS__default = /*#__PURE__*/_interopDefaultLegacy(HICAPS);
var TyroLogo__default = /*#__PURE__*/_interopDefaultLegacy(TyroLogo);

var HealthFundDetails = /*#__PURE__*/function (_Component) {
  _inheritsLoose__default["default"](HealthFundDetails, _Component);

  function HealthFundDetails() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty__default["default"](_assertThisInitialized__default["default"](_this), "getHealthFund", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee(healthFundId, isSelfCheckoutSession) {
        var healthFund;
        return _regeneratorRuntime__default["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return sdk__default["default"].healthfunds.getHealthFund(healthFundId, isSelfCheckoutSession ? {
                  requestConfig: {
                    tokenType: 'session'
                  }
                } : {});

              case 2:
                healthFund = _context.sent;
                return _context.abrupt("return", healthFund);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty__default["default"](_assertThisInitialized__default["default"](_this), "render", function () {
      var _this$props = _this.props,
          overrideClaimItems = _this$props.claimItems,
          enableEdit = _this$props.enableEdit,
          overrideFunderCode = _this$props.funderCode,
          overrideHealthFundAccount = _this$props.healthFundAccount,
          isSelfCheckoutSession = _this$props.isSelfCheckoutSession,
          isFormActive = _this$props.isFormActive,
          overrideMemberName = _this$props.memberName,
          onClickEdit = _this$props.onClickEdit,
          transaction = _this$props.transaction;

      var hasFatalError = _get__default["default"](transaction, 'medicare.hasFatalError', false);

      var healthFundAccount = overrideHealthFundAccount || _get__default["default"](transaction, 'claims[0].healthFundAccount');

      var healthFundId = _get__default["default"](transaction, 'claims[0].healthFund._id') || _get__default["default"](healthFundAccount, 'healthFund._id');

      var claimClientMessage = _get__default["default"](transaction, 'claims[0].clientMessage');

      var claimantHealthFundAccount = _get__default["default"](transaction, 'claims[0].claimantHealthFundAccount');

      var claimantPatient = _get__default["default"](transaction, 'claimantPatient') || _get__default["default"](transaction, 'claimantMember');

      var claimantName = claimantPatient ? _get__default["default"](claimantPatient, 'firstName', '') + " " + _get__default["default"](claimantPatient, 'lastName', '') : null;

      var claimItems = overrideClaimItems || _get__default["default"](transaction, 'claims[0].claimItems');

      var claimStatus = transactionStatus.getOverrideStatus(transaction, _get__default["default"](transaction, 'claims[0].status'));

      var funderCode = overrideFunderCode || _get__default["default"](transaction, 'claims[0].funder.code');

      var funderMessage = _get__default["default"](transaction, '_actions[0].data.message');

      var gatewayCode = _get__default["default"](transaction, 'claims[0].gatewayCode');

      var isHealthPointClaim = !_isEmpty__default["default"](_get__default["default"](transaction, 'claims[0].healthpoint'));
      var memberName = overrideMemberName || _get__default["default"](transaction, 'member.firstName') ? _get__default["default"](transaction, 'member.firstName', '') + " " + _get__default["default"](transaction, 'member.lastName', '') : null;
      var title = 'Health fund';

      if (funders.isMedicare(funderCode)) {
        title = 'Medicare details';
      }

      var isBulkBilled = _get__default["default"](transaction, 'medicare.isBulkBilled');

      var isMedicarePDFAvailable = // @ts-expect-error TS(2532): Object is possibly 'undefined'.
      funders.isMedicare(funderCode) && transaction.status === constants.TRANSACTION_STATUSES.COMPLETED && !hasFatalError;
      return /*#__PURE__*/React__default["default"].createElement(bumbag.Box, null, /*#__PURE__*/React__default["default"].createElement(bumbag.Box, {
        display: "flex",
        marginBottom: "minor-1",
        alignItems: "center",
        justifyContent: "space-between"
      }, /*#__PURE__*/React__default["default"].createElement(components_DescriptionLabel["default"], null, title), (funders.isHICAPS(funderCode) || funders.isOHC(funderCode) || funders.isHealthPoint(funderCode)) && /*#__PURE__*/React__default["default"].createElement(bumbag.Box, {
        display: "flex",
        textAlign: "right",
        fontSize: "100"
      }, "Benefits powered by", ' ', isHealthPointClaim ? /*#__PURE__*/React__default["default"].createElement("img", {
        className: "margin-left-5",
        src: TyroLogo__default["default"],
        alt: "Tyro",
        width: "40px"
      }) : /*#__PURE__*/React__default["default"].createElement("img", {
        className: "margin-left-5",
        src: HICAPS__default["default"],
        alt: "HICAPS"
      }))), /*#__PURE__*/React__default["default"].createElement(bumbag.Set, {
        display: "block",
        orientation: "vertical",
        spacing: "major-2"
      }, isMedicarePDFAvailable && /*#__PURE__*/React__default["default"].createElement(Transactions_components_consumer_MedicareTransactionPDF["default"], {
        transactionId: transaction._id
      }), claimStatus && /*#__PURE__*/React__default["default"].createElement(Transactions_components_consumer_ClaimStatus["default"], {
        description: claimClientMessage,
        funderMessage: funderMessage,
        gatewayCode: gatewayCode,
        status: claimStatus
      }), /*#__PURE__*/React__default["default"].createElement(Loads__default["default"], {
        contextKey: "healthFund-" + healthFundId,
        loadOnMount: true,
        load: function load() {
          return _this.getHealthFund(healthFundId, isSelfCheckoutSession);
        }
      }, function (_ref2) {
        var error = _ref2.error,
            healthFund = _ref2.response,
            isError = _ref2.isError,
            isLoading = _ref2.isLoading,
            isSuccess = _ref2.isSuccess;
        return /*#__PURE__*/React__default["default"].createElement(WithLoadingIndicator["default"], {
          isActive: isLoading
        }, /*#__PURE__*/React__default["default"].createElement(WithErrorMessage["default"], {
          isActive: isError,
          description: "Unable to load health fund",
          error: error
        }, isSuccess && /*#__PURE__*/React__default["default"].createElement(React.Fragment, null, funders.isMedicare(funderCode) && claimantHealthFundAccount && /*#__PURE__*/React__default["default"].createElement("label", {
          className: "label"
        }, "Patient"), /*#__PURE__*/React__default["default"].createElement(HealthFundAccounts_components_HealthFundAccountBox["default"], {
          addonComponent: enableEdit ? /*#__PURE__*/React__default["default"].createElement(bumbag.Button, {
            onClick: onClickEdit,
            palette: "secondary",
            variant: "ghost"
          }, /*#__PURE__*/React__default["default"].createElement("div", {
            className: "flex items-center"
          }, /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
            icon: faEdit.faEdit,
            className: "mr-2"
          }), /*#__PURE__*/React__default["default"].createElement("span", null, "Edit"))) : null,
          backgroundColor: "transparent",
          cardRank: healthFundAccount.cardRank,
          healthFundName: _get__default["default"](healthFund, 'displayName'),
          lastFour: funders.isMedicare(funderCode) && healthFundAccount.lastFour,
          logoBackgroundColor: _get__default["default"](healthFund, 'cardBgColorFront') || _get__default["default"](healthFund, 'primaryColor'),
          logoUrl: _get__default["default"](healthFund, 'cardLogoUrl') || _get__default["default"](healthFund, 'logoSmallUrl'),
          membershipNumber: healthFundAccount.membershipNumber,
          memberName: memberName
        }), funders.isMedicare(funderCode) && claimantHealthFundAccount && /*#__PURE__*/React__default["default"].createElement(React.Fragment, null, /*#__PURE__*/React__default["default"].createElement("label", {
          className: "label"
        }, "Claimant"), /*#__PURE__*/React__default["default"].createElement(HealthFundAccounts_components_HealthFundAccountBox["default"], {
          backgroundColor: "transparent",
          cardRank: claimantHealthFundAccount.cardRank,
          className: "margin-top-10",
          healthFundName: _get__default["default"](healthFund, 'displayName'),
          lastFour: funders.isMedicare(funderCode) && healthFundAccount.lastFour,
          logoBackgroundColor: _get__default["default"](healthFund, 'cardBgColorFront') || _get__default["default"](healthFund, 'primaryColor'),
          logoUrl: _get__default["default"](healthFund, 'cardLogoUrl') || _get__default["default"](healthFund, 'logoSmallUrl'),
          membershipNumber: claimantHealthFundAccount.membershipNumber,
          memberName: claimantName
        })))));
      }), (funders.isHICAPS(funderCode) || funders.isOHC(funderCode) || funders.isHealthPoint(funderCode)) && _this.renderClaimableServices({
        claimItems: claimItems
      }), isHealthPointClaim && _get__default["default"](transaction, 'claims[0].healthpoint.freeText.length', 0) > 0 && _this.renderHealthPointFreeText({
        freeText: _get__default["default"](transaction, 'claims[0].healthpoint.freeText')
      }), funders.isMedicare(funderCode) && !isBulkBilled && _this.renderExpectedBenefits({
        claimItems: claimItems
      }), funders.isMedicare(funderCode) && isFormActive && /*#__PURE__*/React__default["default"].createElement(HealthFundAccounts_components_MedicareDefaultAddress.MedicareDefaultAddress, null), funders.isMedicare(funderCode) && isFormActive && /*#__PURE__*/React__default["default"].createElement(HealthFundAccounts_components_MedicareBankDetails.MedicareBankDetails, null)));
    });

    _defineProperty__default["default"](_assertThisInitialized__default["default"](_this), "renderClaimableServices", function (_ref3) {
      var claimItems = _ref3.claimItems;
      return /*#__PURE__*/React__default["default"].createElement(bumbag.Box, null, /*#__PURE__*/React__default["default"].createElement("label", {
        className: "label"
      }, "Claimable services"), /*#__PURE__*/React__default["default"].createElement(bumbag.List, {
        listStyleType: "disc",
        listStylePosition: "outside",
        marginLeft: "major-3"
      }, claimItems && claimItems.map(function (item, i) {
        return (
          /*#__PURE__*/

          /* eslint-disable react/no-array-index-key */
          React__default["default"].createElement(bumbag.List.Item, {
            key: i
          }, /*#__PURE__*/React__default["default"].createElement(bumbag.Text, {
            fontSize: "150"
          }, item.displayName))
        );
      })));
    });

    _defineProperty__default["default"](_assertThisInitialized__default["default"](_this), "renderHealthPointFreeText", function (_ref4) {
      var freeText = _ref4.freeText;
      return /*#__PURE__*/React__default["default"].createElement(bumbag.Box, null, /*#__PURE__*/React__default["default"].createElement("label", {
        className: "label"
      }, "Health Fund Message"), /*#__PURE__*/React__default["default"].createElement(bumbag.Text, {
        fontSize: "12px",
        fontWeight: "semibold",
        whiteSpace: "pre-wrap"
      }, freeText));
    });

    _defineProperty__default["default"](_assertThisInitialized__default["default"](_this), "renderExpectedBenefits", function (_ref5) {
      var claimItems = _ref5.claimItems;
      return /*#__PURE__*/React__default["default"].createElement(bumbag.Box, null, /*#__PURE__*/React__default["default"].createElement("label", {
        className: "label"
      }, "Benefit"), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "space-y-2"
      }, claimItems && claimItems.map(function (item, i) {
        // @ts-expect-error TS(2339): Property 'amountExpectedBenefitString' does not ex... Remove this comment to see the full error message
        if (!item.amountExpectedBenefitString) {
          return null;
        }

        return (
          /*#__PURE__*/

          /* eslint-disable react/no-array-index-key */
          React__default["default"].createElement(bumbag.Box, {
            key: i,
            fontSize: "150"
          }, /*#__PURE__*/React__default["default"].createElement(bumbag.Text, {
            fontWeight: "semibold"
          }, item.displayName), /*#__PURE__*/React__default["default"].createElement("br", null), /*#__PURE__*/React__default["default"].createElement(bumbag.Text, null, "The typical benefit for this item is", ' ', /*#__PURE__*/React__default["default"].createElement(bumbag.Text, {
            fontWeight: "semibold"
          }, item.amountExpectedBenefitString)))
        );
      })));
    });

    return _this;
  }

  return HealthFundDetails;
}(React.Component);

_defineProperty__default["default"](HealthFundDetails, "defaultProps", {
  claimItems: undefined,
  enableEdit: false,
  funderCode: false,
  healthFundAccount: undefined,
  isSelfCheckoutSession: false,
  isFormActive: false,
  onClickEdit: undefined,
  memberName: undefined,
  transaction: undefined
});

exports["default"] = HealthFundDetails;
